import { Avatar } from '../../components/Avatar';
import { CategoryTag, VerifiedBadge } from '../../components/Badges';
import { Icon } from '../../components/Icon';
import { Paper } from '../../components/Paper';
import type { Category } from '../../lib/api';
import card from '../posts/PostCard.module.css';
import styles from './Landing.module.css';

interface Sample {
  name: string;
  hue: number;
  when: string;
  category: Category | null;
  body: string;
  replies: string;
}

// Illustrative only: the kinds of notes a board holds. Not real posts.
const SAMPLES: Sample[] = [
  {
    name: 'Maria G.',
    hue: 12,
    when: '18 minutes ago',
    category: 'lost_found',
    body: "Found a friendly brown dog near the wash off Golder Ranch Road. No collar. He's safe in our yard. Anyone recognize him?",
    replies: '6 neighbors are talking about this',
  },
  {
    name: 'Tom R.',
    hue: 205,
    when: '2 hours ago',
    category: 'alert',
    body: 'Planned power outage Thursday 8am to noon for the streets east of Oracle Road. The notice came in the mail.',
    replies: '3 replies',
  },
  {
    name: 'Denise P.',
    hue: 140,
    when: 'Yesterday at 4:12 PM',
    category: 'question',
    body: 'Who do you all use for irrigation repair? Our drip lines sprang about nine leaks after the freeze.',
    replies: '9 replies',
  },
];

export function SampleNotes() {
  return (
    <ul className={styles.samples} aria-label="Example notes">
      {SAMPLES.map((s) => (
        <li key={s.name}>
          <Paper
            as="article"
            padded={false}
            className={[card.card, card.static, s.category && card.hasTab].filter(Boolean).join(' ')}
            aria-label={`Example note from ${s.name}`}
          >
            {s.category && <CategoryTag category={s.category} className={card.tab} />}
            <header className={card.header}>
              <Avatar name={s.name} hue={s.hue} />
              <div className={card.who}>
                <div className={card.nameRow}>
                  <span className={card.name}>{s.name}</span>
                  <VerifiedBadge />
                </div>
                <span className={card.meta}>{s.when}</span>
              </div>
            </header>
            <p className={card.body}>{s.body}</p>
            <footer className={card.footer}>
              <span className={card.replies}>
                <Icon name="reply" size={18} />
                {s.replies}
              </span>
            </footer>
          </Paper>
        </li>
      ))}
    </ul>
  );
}
